// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderWithBody_root__uPhB1","in-view":"HeaderWithBody_in-view__ioIop","center":"HeaderWithBody_center__1Av0G","centerText":"HeaderWithBody_centerText__vPAAw"};